import { styled, css } from 'styled-components';

export const Container = styled.div<{ $styled: { maxLength: number | undefined; $prefix: unknown } }>`
  display: flex;
  align-items: center;
  ${({ $styled: { maxLength } }) =>
    !!maxLength &&
    css`
      & input,
      textarea {
        border-bottom-right-radius: 0 !important;
        border-top-right-radius: 0 !important;
        &:focus {
          z-index: 1;
        }
      }
    `}
  ${({ $styled: { $prefix } }) =>
    !!$prefix &&
    css`
      & input,
      textarea {
        border-bottom-left-radius: 0 !important;
        border-top-left-radius: 0 !important;
        &:focus {
          z-index: 1;
        }
      }
    `}
`;
export const Counter = styled.div<{ $styled: { $textarea: boolean; rows: number } }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey100_1};
  height: ${({ $styled: { $textarea, rows } }) => ($textarea && rows !== 1 ? `${rows * 38}px` : '38px')};
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-left: none;
`;

export const Prefix = styled.div<{ $styled: { $textarea: boolean; rows: number } }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.black_1};
  height: ${({ $styled: { $textarea, rows } }) => ($textarea && rows !== 1 ? `${rows * 38}px` : '38px')};
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  background-color: ${({ theme }) => theme.colors.grey01_1};
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  border-right: none;
`;
